import { useEffect, useState } from 'react';
import coreApi from '../../utils/coreApi';

export const RESUME_PARSING_SERVICE_UNAVAILABLE = {
  title: 'Resume Parsing Service Unavailable',
  message: 'The resume parsing service is not responding. Upload and analysis are temporarily unavailable. Please try again later.',
};

export const RESUME_AI_QUOTA_EXCEEDED = {
  title: 'Resume AI Service Unavailable',
  message: 'AI service quota has been exceeded. Resume uploads are temporarily disabled. Please check your AI provider billing or wait for the quota to reset.',
};

export function useResumeUploadAvailability() {
  const [aiHealthy, setAiHealthy] = useState(true);
  const [healthChecked, setHealthChecked] = useState(false);
  const [aiQuotaExceeded, setAiQuotaExceeded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkAvailability = async () => {
      try {
        const result = await coreApi.get('/resume-parsing/health');
        if (!isMounted) return;
        setAiHealthy(result.ai_automation_status !== 'unreachable');
      } catch {
        if (!isMounted) return;
        setAiHealthy(false);
      } finally {
        if (isMounted) {
          setHealthChecked(true);
        }
      }

      try {
        const quotaResult = await coreApi.get('/openai-status');
        if (!isMounted) return;

        const quotaData = quotaResult?.data || quotaResult;
        const isQuotaError = quotaData?.error_code === 'quota_exceeded'
          || quotaData?.status === 'error'
          || (quotaData?.message || '').toLowerCase().includes('quota');

        setAiQuotaExceeded(isQuotaError);
      } catch {
        if (isMounted) {
          setAiQuotaExceeded(false);
        }
      }
    };

    void checkAvailability();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    aiHealthy,
    healthChecked,
    aiQuotaExceeded,
  };
}
